exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#function-management .head[data-v-036fe222]  .el-input{width:200px}#function-management[data-v-036fe222]  .el-card__body{height:100%}", ""]);

// exports
